import { render } from "./Tiktok.vue?vue&type=template&id=397c6126&scoped=true"
import script from "./Tiktok.vue?vue&type=script&lang=js"
export * from "./Tiktok.vue?vue&type=script&lang=js"

import "./Tiktok.vue?vue&type=style&index=0&id=397c6126&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397c6126"]])

export default __exports__